import { ActiveFilterChip } from './active-filter-chip';
import { useTableStates } from '@src/design-system/molecules/ticlick-table/hooks/use-table-states';

export function ActiveFiltersBar() {
  const { tableFilters } = useTableStates();

  const shouldShowActiveBar = !!tableFilters?.staticFilters?.length;

  if (!shouldShowActiveBar) return null;

  return (
    <div className='mb-4 border-t border-gray-100 p-4 pb-0 flex items-center justify-between gap-2 px-2'>
      <div className='flex flex-1 overflow-x-auto items-center gap-2'>
        {tableFilters?.staticFilters?.map((group) => {
          return (
            <div
              key={group.field}
              className='shrink-0'
            >
              <ActiveFilterChip staticFilter={group} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
